import { useQuery } from '@tanstack/react-query';
import { ScheduleCoach } from '#types/schedule';
import { fetcher } from '../libs';
import queryKeys from '../queryKeys';

interface Params {
  /** 조회할 날짜 (YYYY-MM-DD) */
  startAt: string;
  /** 요청할 일수 (기본값 7)  */
  durationDays: number;
}

/**
 * 코치 - 일정 가져오기
 * @link https://api-dev.fibud.kr/api#/수업%20-%20일정/SchedulesController_findCoachSchedules
 * @param id
 * @param status
 * @returns
 */
export function useScheduleCoachListQuery({ startAt, durationDays }: Params) {
  return useQuery(
    [queryKeys.SCHEDULE, startAt, durationDays],
    () =>
      fetcher<ScheduleCoach[]>('/schedules/coach/v2', {
        params: { startAt, durationDays }
      }),
    {
      enabled: !!startAt
    }
  );
}
